import React from "react";
import PropTypes from "prop-types";

import { Field, Control, Label, Select, Icon } from "rbx";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Products } from "../../containers/Products";
import { ErrorMessage } from "../ErrorMessage";

const ProductSelect = ({
  value,
  label,
  size,
  valueKey,
  name,
  onChange,
  icon,
  required,
  readOnly,
  where
}) => (
  <Field>
    <Label size={size}>{label}</Label>

    <Products
      variables={{
        where,
        orderByMulti: ["ProductCode_ASC"]
      }}
    >
      {({ data, loading, error }) => {
        if (error) return <ErrorMessage error={error} />;
        return (
          <Control iconLeft size={size}>
            <Select.Container
              fullwidth
              color={error ? "danger" : "secondary"}
              size={size}
              state={loading ? "loading" : null}
            >
              {data && data.Products ? (
                <Select
                  disabled={readOnly}
                  name={name}
                  required={required}
                  value={value}
                  onChange={onChange}
                >
                  <Select.Option value={0}>{label}</Select.Option>
                  {!loading &&
                    data.Products.map(
                      ({ ProductCode, Description, ...keys }, i) => (
                        <Select.Option
                          key={`product-select-${i}`}
                          value={keys[valueKey]}
                        >
                          {ProductCode} - {Description}
                        </Select.Option>
                      )
                    )}
                </Select>
              ) : null}
            </Select.Container>
            {icon && (
              <Icon align="left" size="small">
                <FontAwesomeIcon icon={icon} />
              </Icon>
            )}
          </Control>
        );
      }}
    </Products>
  </Field>
);

ProductSelect.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  name: PropTypes.string,
  onChange: PropTypes.func,
  label: PropTypes.string,
  size: PropTypes.string,
  valueKey: PropTypes.string,
  icon: PropTypes.string,
  required: PropTypes.bool,
  readOnly: PropTypes.bool,
  where: PropTypes.object
};

ProductSelect.defaultProps = {
  value: 0,
  valueKey: "RecId"
};
export default ProductSelect;
